<script setup>
import { computed } from 'vue'
import {
  transformMarkedText
} from '@/composables/splitSentence';
const props = defineProps({
  title: { type: String, required: true },      
  tone:  { type: String, default: 'neutral' },  
  numbers: { type: Array, default: () => null },
  colors:  { type: Array, default: () => null },
  directions:  { type: Array, default: () => null },
  description: { type: String, default: '' },   
})

const hasNumbers = computed(() => Array.isArray(props.numbers) && props.numbers.length > 0)
const hasColors  = computed(() => Array.isArray(props.colors)  && props.colors.length  > 0)
const numberText = computed(() => hasNumbers.value ? props.numbers.join(', ') : '')
const hasDirections  = computed(() => Array.isArray(props.directions)  && props.directions.length  > 0)

// 시공간 데이터 중 시간 데이터 그리드 만들기
const dirTokens = computed(() =>
  Array.isArray(props.directions) ? props.directions.filter(Boolean) : []
)
const isTimeToken = (s) => typeof s === 'string' && s.includes('시')
const parts = computed(() => {
  const arr = dirTokens.value
  const timeIdx = arr
    .map((t, i) => (isTimeToken(t) ? i : -1))
    .filter(i => i >= 0)

  if (timeIdx.length === 0) {
    return { prefix: arr, time: [], suffix: [] }
  }
  const start = timeIdx[0]
  const end   = timeIdx[timeIdx.length - 1]
  return {
    prefix: arr.slice(0, start),
    time:   arr.slice(start, end + 1),
    suffix: arr.slice(end + 1),
  }
})
const makeTimeGrid = (arr) => {
  const items = Array.isArray(arr) ? arr.filter(Boolean).slice(0, 4) : []
  if (items.length <= 2) return { cols: 1, items }
  const even = items.length % 2 === 0 ? items : [...items, null] // 3개면 빈칸 하나 채우기
  return { cols: 2, items: even }
}
const timeGrid = computed(() => makeTimeGrid(parts.value.time))

</script>

<template>
  <div class="yh-mini-card" :class="`is-${tone}`">
    <div class="yh-card__title-badge">{{ title }}</div>

    <div class="yh-card__content">
      <template v-if="hasNumbers">
        <div class="yh-card__content-numbers">{{ numberText }}</div>
      </template>

      <template v-else-if="hasColors">
        <div class="yh-card__content-swatches">
          <span
            v-for="(c, i) in colors"
            :key="i"
            class="swatch"
            :style="{ background: c }"
            aria-hidden="true"
          />
        </div>
      </template>

      <template v-else-if="hasDirections">
        <div class="yh-card__directions-wrapper">
          <div class="yh-card__dir-line" v-if="parts.prefix.length">
            <div
              v-for="(d, i) in parts.prefix"
              :key="'p'+i"
              class="yh-card__content-directions"
            >
              {{ d }}
            </div>
          </div>
          <div
            v-if="timeGrid.items.length"
            class="yh-card__time-grid"
            :class="timeGrid.cols === 2 ? 'cols-2' : 'cols-1'"
          >
            <div
              v-for="(t, i) in timeGrid.items"
              :key="'t'+i"
              class="yh-card__time-item"
            >
              <span v-if="t">{{ t }}</span>
              <span v-else class="placeholder">&nbsp;</span>
            </div>
          </div>
          <div class="yh-card__dir-line" v-if="parts.suffix.length">
            <div
              v-for="(d, i) in parts.suffix"
              :key="'s'+i"
              class="yh-card__content-directions"
            >
              {{ d }}
            </div>
          </div>
        </div>
        <div class="yh-card__divider"/>
      </template>

      <!-- <p class="yh-card__desc" v-if="description">{{ description }}</p> -->
       <p 
        class="yh-card__desc"
        v-html="transformMarkedText(description)"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
